import React, { useState } from "react";
import Sidebar from "./Sidebar";
import ButtonMovil from "./ButtonMovil";
import Content from "./Content";
const Layout = ({ children, user }) => {
  const [sidebar, setSidebar] = useState(false);
  const handleSidebar = () => {
    setSidebar(!sidebar);
  };
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-6">
      <Sidebar sidebar={sidebar} user={user} />
      <ButtonMovil sidebar={sidebar} handleSidebar={handleSidebar} />
      <Content children={children} user={user} >{children}</Content>
    </div>
  );
};
export default Layout;
